var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.285714 13v-11.657143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 1.342857h6.171429"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.371429 4.085714h4.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m3.742857 6.828571h3.428572"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.702857 9.571429h2.468572"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m11.285714 13 1.714286-1.714286"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m9.571429 11.285714 1.714285 1.714286"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.77c7c4ee50142c40aadcc9cc61446ee9.svg";
export { ForwardRef as ReactComponent };